import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';

export class AdminEQueryBuildPart extends BaseBuildPart {
    constructor(private readonly activityReportsHelperParams: HelperParams,
                parent: BaseBuildPart) {
        super(activityReportsHelperParams, parent, ['admin-e-query']);
    }

    public hideEQueries() {
        return new BaseBuildPart(this.activityReportsHelperParams, this, ['hide']);
    }

    public escalationEmails() {
        return new BaseBuildPart(this.activityReportsHelperParams, this, ['escalation-emails']);
    }

    public usageReport() {
        return new BaseBuildPart(this.activityReportsHelperParams, this, ['usage-report']);
    }

    public eQuerySummary() {
        return new BaseBuildPart(this.activityReportsHelperParams, this, ['query-summary']);
    }
}
